<template>
  <nav class="navbar navbar-expand-sm navbar-light d-block container-xxl p-1 my-1">
    <div class="row g-1">
      <div
        class="col-10"
        :class="`${presetDate ? 'col-sm-4 col-lg-2' : 'col-sm-4'}`"
      >
        <p class="text-start" v-if="presetDate">
          {{
            new Date(presetDate).toLocaleDateString($i18n.locale, {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          }}
        </p>
        <multiselect
          v-model="dayValue"
          :multiple="false"
          :options="dayOptions"
          :close-on-select="true"
          label="label"
          track-by="value"
          :placeholder="
            $t('general.selectPlaceholder', { item: $t('general.date') })
          "
          :showLabels="false"
          v-else
        />
      </div>
      <div class="col-2 d-sm-none d-flex">
        <button
          class="navbar-toggler m-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div
        class="col-12"
        :class="`${presetDate ? 'col-sm-8 col-lg-9' : 'col-sm-8'}`"
      >
        <multiselect
          v-model="selectedTimeSheets"
          :options="timeSheetOptions"
          mode="multiple"
          :multiple="true"
          :close-on-select="true"
          label="label"
          track-by="value"
          :placeholder="
            $t('general.selectPlaceholder', { item: $t('general.teeSheet') })
          "
          :selectLabel="$t('multiselect.selectLabel')"
          :selectGroupLabel="$t('multiselect.selectGroupLabel')"
          :selectedLabel="$t('multiselect.selectedLabel')"
          :deselectLabel="$t('multiselect.deselectLabel')"
          :deselectGroupLabel="$t('multiselect.deselectGroupLabel')"
          :searchable="false"
        />
      </div>
    </div>
    <div
      class="row g-1 mt-1 collapse navbar-collapse justify-content-between"
      id="navbarNav"
    >
      <div
        class="col-12 col-sm-6 col-lg-2 order-2 order-sm-2 my-auto text-sm-center"
      >
        <div class="d-block">
          <label class="nx-form-label">{{
            $t("general.singleHoleMode")
          }}</label>
        </div>
        <Toggle
          v-model="singleHoleModeValue"
          @change="
            setSingleHoleMode(singleHoleModeValue);
            replaceQuery();
          "
          onLabel="On"
          offLabel="Off"
        />
      </div>
      <div
        class="col-12 col-lg-3 col-sm-4 order-3 order-lg-3"
        v-if="singleHoleMode == true"
      >
        <label class="nx-form-label">{{ $t("general.hole") }}</label>
        <multiselect
          v-model="selectedSingleHoleValue"
          :multiple="false"
          :options="holeOptions"
          :close-on-select="true"
          label="label"
          track-by="value"
          :placeholder="
            $t('general.selectPlaceholder', { item: $t('general.hole') })
          "
          @select="
            setSelectedSingleHole($event?.value);
            replaceQuery();
          "
          @remove="
            setSelectedSingleHole(null);
            replaceQuery();
          "
        />
      </div>
      <div
        class="col-12 col-lg-3 col-sm-4 order-3 order-lg-3"
        v-if="hideStartHoleSort == false && singleHoleMode == false"
      >
        <label class="nx-form-label">{{
          $t("general.sortPlaceholder", { item: $t("general.startHole") })
        }}</label>
        <multiselect
          v-model="startHoleSortValue"
          :multiple="false"
          :options="startHoleOptions"
          :close-on-select="true"
          label="label"
          track-by="value"
          :placeholder="
            $t('general.selectPlaceholder', { item: $t('general.startHole') })
          "
        />
      </div>
      <div class="col-12 col-lg-3 col-sm-4 order-4 order-lg-4">
        <label class="nx-form-label">{{
          $t("message.hideFinishedFlights")
        }}</label>
        <multiselect
          v-model="flightTimeLimitValue"
          :multiple="false"
          :options="flightTimeLimitOptions"
          :close-on-select="true"
          label="label"
          track-by="value"
          :placeholder="
            $t('general.selectPlaceholder', { item: $t('general.time') })
          "
        />
      </div>
      <div
        class="col-12 col-lg-3 col-sm-4 order-5 order-lg-5"
        v-if="hideStartHoleFilter == false"
      >
        <label class="nx-form-label">{{ $t("general.startHoleFilter") }}</label>
        <multiselect
          v-model="startHoleFilter"
          :multiple="false"
          :options="startHoleOptions"
          :close-on-select="true"
          label="label"
          track-by="value"
          :placeholder="
            $t('general.selectPlaceholder', { item: $t('general.startHole') })
          "
        />
      </div>
      <div
        class="col-12 col-lg-1 col-sm-6 order-5 order-sm-1 my-auto text-sm-center"
      >
        <div class="d-block">
          <label class="nx-form-label">{{
            $t("general.show", { item: $t("general.club") })
          }}</label>
        </div>
        <Toggle
          v-model="showHomeClub"
          @change="showHomeClubToggle($event)"
          onLabel="On"
          offLabel="Off"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import Toggle from "@vueform/toggle";
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { store } from "@/store";
import Multiselect from "vue-multiselect";

export default defineComponent({
  name: "TimeSheetSelector",
  components: {
    Multiselect,
    Toggle,
  },
  data() {
    return {
      integrated: document.currentScript?.getAttribute("integrated"),
      dayValue: null,
      selectedTimeSheets: null,
      startHoleFilter: null,
      startHoleSortValue: null,
      flightTimeLimitValue: null,
      dataLoaded: false,
      singleHoleModeValue: false,
      selectedSingleHoleValue: null,
    };
  },
  mounted() {
    this.singleHoleModeValue = this.singleHoleMode;
    this.selectedSingleHoleValue = this.holeOptions.find(
      (o) => o.value === this.selectedSingleHole
    );
  },
  created() {
    if (this.presetDate == null && this.timeSheets?.length > 0) {
      let nearestTimeSheet;
      if (this.sheets?.length > 0) {
        nearestTimeSheet = this.timeSheets.find(
          (tS) => tS.id == this.sheets[0]
        );
      } else {
        const testDate = new Date();
        let bestDiff = -new Date(0, 0, 0).valueOf();
        let currDiff = 0;
        for (let i = 0; i < this.timeSheets.length; ++i) {
          currDiff = Math.abs(new Date(this.timeSheets[i].date) - testDate);
          if (currDiff < bestDiff) {
            nearestTimeSheet = this.timeSheets[i];
            bestDiff = currDiff;
          }
        }
      }
      if (nearestTimeSheet?.date != null) {
        this.dayValue = {
          label: new Date(nearestTimeSheet?.date).toLocaleDateString(
            this.$i18n.locale,
            {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          ),
          value: nearestTimeSheet?.date,
        };
      }
    }

    if (this.presetDate != null) {
      if (this.sheets?.length > 0) {
        this.selectedTimeSheets = this.timeSheetOptions.filter((o) =>
          this.sheets.includes(o.value)
        );
      } else {
        this.selectedTimeSheets =
          this.timeSheetOptions.length > 0 ? [this.timeSheetOptions[0]] : [];
      }
    }

    /* if (this.sheets?.length > 0) {
      this.selectedTimeSheets = this.timeSheetOptions.filter((o) =>
        this.sheets.includes(o.value)
      );
    } else {
      this.selectedTimeSheets =
        this.timeSheetOptions.length > 0 ? [this.timeSheetOptions[0]] : [];
    } */

    if (this.startHole) {
      this.startHoleFilter = this.holeOptions.find(
        (o) => o.value == this.startHole
      );
    }

    if (this.startHoleSort) {
      this.startHoleSortValue = this.startHoleOptions.find(
        (o) => o.value == this.startHoleSort
      );
    }

    if (this.flightTimeLimit) {
      this.flightTimeLimitValue = this.flightTimeLimitOptions.find(
        (o) => o.value == this.flightTimeLimit
      );
    }

    this.dataLoaded = true;
  },
  methods: {
    ...mapActions({
      setDayValue: "navigation/setDayValue",
      setTimeSheets: "navigation/setTimeSheets",
      setStartHole: "navigation/setStartHole",
      setStartHoleSort: "navigation/setStartHoleSort",
      setShowHomeClub: "navigation/setShowHomeClub",
      setSingleHoleMode: "navigation/setSingleHoleMode",
      setSelectedSingleHole: "navigation/setSelectedSingleHole",
    }),
    showHomeClubToggle() {
      this.setShowHomeClub(!this.showHomeClub);
    },
    replaceQuery() {
      if (!this.integrated) {
        const query = {};
        if (this.presetDate) {
          query.date = this.presetDate.substring(0, 10);
        }
        if (this.sheets) {
          query.sheets = this.sheets.join(",");
        }
        if (this.startHole) {
          query.startHole = this.startHole;
        }
        if (this.startHoleSort) {
          query.startHoleSort = this.startHoleSort;
        }
        if (this.flightTimeLimit) {
          query.flightTimeLimit = this.flightTimeLimit;
        }
        if (this.$route.query.iframe) {
          query.iframe = this.$route.query.iframe;
        }
        if (this.$route.query.token) {
          query.token = this.$route.query.token;
        }
        if (this.$route.query.hideStartHoleFilter) {
          query.hideStartHoleFilter = this.$route.query.hideStartHoleFilter;
        }
        if (this.$route.query.hideStartHoleSort) {
          query.hideStartHoleSort = this.$route.query.hideStartHoleSort;
        }
        if (this.singleHoleMode) {
          query.singleHoleMode = this.singleHoleMode;
          if (this.selectedSingleHole) {
            query.selectedSingleHole = this.selectedSingleHole;
          }
        }
        this.$router.replace({
          name: "main.timeSheet",
          query,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheets/all",
      sheets: "navigation/getTimeSheets",
      presetDate: "navigation/getPresetDate",
      startHole: "navigation/getStartHole",
      startHoleSort: "navigation/getStartHoleSort",
      flightTimeLimit: "navigation/getFlightTimeLimit",
      showHomeClub: "navigation/getShowHomeClub",
      singleHoleMode: "navigation/getSingleHoleMode",
      selectedSingleHole: "navigation/getSelectedSingleHole",
    }),
    holeOptions() {
      let holes = [];
      for (let index = 1; index <= 18; index++) {
        holes.push({
          value: index,
          label: `${this.$t("general.hole")} ${index}`,
        });
      }
      return holes;
    },
    startHoleOptions() {
      return [
        {
          value: 1,
          label: `${this.$t("general.hole")} 1`,
        },
        {
          value: 10,
          label: `${this.$t("general.hole")} 10`,
        },
      ];
    },
    flightTimeLimitOptions() {
      return [
        {
          value: 1,
          label: `1 ${this.$t("general.minute")}`,
        },
        {
          value: 5,
          label: `5 ${this.$t("general.minutes")}`,
        },
        {
          value: 15,
          label: `15 ${this.$t("general.minutes")}`,
        },
        {
          value: 30,
          label: `30 ${this.$t("general.minutes")}`,
        },
        {
          value: 60,
          label: `1 ${this.$t("general.hour")}`,
        },
      ];
    },
    hideStartHoleFilter() {
      return this.$route.query.hideStartHoleFilter == "true";
    },
    hideStartHoleSort() {
      return this.$route.query.hideStartHoleSort == "true";
    },
    dayOptions() {
      if (this.timeSheets == null) {
        return [];
      }
      return this.timeSheets
        .map((timeSheet) => {
          return timeSheet.date;
        })
        .filter((option, index, self) => {
          return self.indexOf(option) == index;
        })
        .map((value) => {
          return {
            label: new Date(value).toLocaleDateString(this.$i18n.locale, {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
            value: value,
          };
        });
    },
    timeSheetOptions() {
      const searchDate = this.presetDate ?? this.dayValue?.value ?? null;
      if (searchDate == null || this.timeSheets == null) {
        return [];
      }
      const options = this.timeSheets
        .filter((timeSheet) => timeSheet.date == searchDate)
        .map((timeSheet) => {
          return {
            label: timeSheet.title,
            value: timeSheet.id,
          };
        });
      options.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      return options;
    },
    query: () => this.$route.query,
  },
  watch: {
    singleHoleMode(newVal) {
      if (newVal) {
        this.startHoleSortValue = null;
      }
    },
    sheets(newVal) {
      this.$root.subscribeChannels(newVal);
      store.dispatch("timeSheets/setTimeSheetIds", newVal);
    },
    startHole(newVal) {
      this.startHoleFilter = this.holeOptions.find((o) => o.value == newVal);
    },
    startHoleSort(newVal) {
      this.startHoleSortValue = this.holeOptions.find((o) => o.value == newVal);
    },
    flightTimeLimit(newVal) {
      this.flightTimeLimitValue = this.flightTimeLimitOptions.find(
        (o) => o.value == newVal
      );
    },
    timeSheetOptions(newVal) {
      if (newVal) {
        if (this.sheets) {
          const filteredValues = newVal.filter((tSO) =>
            this.sheets.includes(tSO.value)
          );
          this.selectedTimeSheets =
            filteredValues.length > 0 ? filteredValues : null;
        }
        if (this.selectedTimeSheets == null && newVal.length > 0) {
          const firstOption = newVal[0];
          this.selectedTimeSheets = [firstOption];
        }
      }
    },
    dayValue(newVal) {
      store.dispatch("navigation/setDayValue", newVal);
      if (this.dataLoaded && newVal == null) {
        store.dispatch("navigation/setFlightTimeLimit", null);
        store.dispatch("navigation/setStartHole", null);
        store.dispatch("navigation/setTimeSheets", []);
        this.replaceQuery();
      }
    },
    selectedTimeSheets(newVal) {
      const nextSheets = newVal?.map((v) => v.value) ?? [];
      if (nextSheets.length == 0) {
        store.dispatch("navigation/setFlightTimeLimit", null);
        store.dispatch("navigation/setStartHole", null);
      }
      store.dispatch("navigation/setTimeSheets", nextSheets);
      this.replaceQuery();
    },
    startHoleFilter(newVal) {
      store.dispatch("navigation/setStartHole", newVal?.value ?? null);
      this.replaceQuery();
    },
    startHoleSortValue(newVal) {
      store.dispatch("navigation/setStartHoleSort", newVal?.value ?? null);
      this.replaceQuery();
    },
    flightTimeLimitValue(newVal) {
      store.dispatch("navigation/setFlightTimeLimit", newVal?.value ?? null);
      this.replaceQuery();
    },
  },
});
</script>

<style lang="scss">
.indicator {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 50%;

  &.open {
    background: #28b62c;
    animation: pulse-animation 2s infinite linear;
    -webkit-animation: pulse-animation 2s infinite linear;
  }

  &.connecting {
    background: #28b62c;
    animation: pulse-animation 0.5s infinite linear;
    -webkit-animation: pulse-animation 0.5s infinite linear;
  }

  &.closing {
    background: orange;
    animation: pulse-animation 0.5s infinite linear;
    -webkit-animation: pulse-animation 0.5s infinite linear;
  }

  &.offline {
    background: #ff4136;
  }

  &.unknown {
    background: gray;
  }
}

@-webkit-keyframes pulse-animation {
  0% {
    -webkit-transform: scale(1);
  }
  25% {
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.2);
  }
  75% {
    -webkit-transform: scale(1);
  }
  100% {
    -webkit-transform: scale(1);
  }
}

.nx-form-label {
  font-weight: 500;
  font-size: 0.875rem;
  color: #0f5132a6;
  margin: 0;
}

.multiselect__placeholder {
  color: #638e7aa8;
}
</style>
<style src="@vueform/toggle/themes/default.css"></style>
